import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function CalcAnalysisGraph({ id, simObj, setSimObj }) {
    const [availableBudgetPrice, setAvailableBudgetPrice] = useState(null);
    const availableBudget = parseInt(simObj?.laststate?.availableBudget);
    const TotalProcurementCost = parseInt(Math.round(simObj?.laststate?.totalProcurementCost));
    const linedUpOrderCost = parseInt(simObj?.laststate?.linedUpOrderCost);
    function formatNumberWithCommas(number) {
        //Added for tooltip formatter to 1,334
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    function applyAccessibility(chart) {
        if (chart && chart.renderTo) {
        const svg = chart.renderTo.querySelector("svg.highcharts-root");
        if (svg) {
            setTimeout(() => {
            svg.setAttribute("role", "img");
            svg.setAttribute(
            "aria-label",
            "Pie chart showing Remaining Budget."
            );

            const oldDesc = svg.querySelector("desc");
            if (oldDesc) oldDesc.remove();
            if (chart.series && chart.series.length > 0 && chart.series[0].data?.length > 0) {
            const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
            desc.textContent =
            "This pie chart shows the remaining budget versus the total procurement cost. " +
            `The values are ${chart.series[0].data
                .map((d) => `${d.name}: ${d.y?.toFixed() || 0}`)
                .join(", ")}.`;
            svg.insertBefore(desc, svg.firstChild);
            }
            },0);
        }
        }
    }
    var chart = {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        marginTop: 50,
        events: {
            render: function () {
                applyAccessibility(this);
            },
            redraw: function () {
                applyAccessibility(this);
            }
        }
    };
    var title = {
        text: 'Remaining Budget',
        align: "left",
        style: {
            fontSize: "12px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
        formatter: function () {
            //<strong>${this.key} Percentage: ${this.percentage.toFixed(2)}%</strong><br/>
            return `<span>${this.key}: <strong>${formatNumberWithCommas(this.y)}</strong><br/>Lined-Up Order Cost: <strong>${formatNumberWithCommas(linedUpOrderCost)}</strong></strong></span>`;
        },
        borderWidth: 2,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '11px',
        }
    };
    var legend = {
        enabled: false,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        pie: {
            center: [null, 80],
            dataLabels: {
                enabled: false,
            },

            showInLegend: false,
            point: {
                events: {
                    legendItemClick: function (e) {
                        return false;
                    }
                }
            }
        },
    };
    var series = [
        {
            type: "pie",
            // innerSize: "30%",
            borderRadius: 0,
            data: [{
                name: "Remaining Budget",
                y: availableBudget, //
                //color: "#ff5252", // Set the background color for 'Ordering Cost'
                color: {
                    pattern: {
                      path: 'M 0 10 L 10 0',
                      width: 10,
                      height: 10,
                      color: '#FFFFFF',
                      backgroundColor: "#E6151F"
            
                    }
                }
            },
            {
                name: "Total Procurement Cost",
                y: TotalProcurementCost,
                //color: "#c6c9c5", // Set the background color for 'Ordering Cost'
                color: {
                    pattern: {
                        path: 'M 0 5 L 10 5', // Horizontal line
                        width: 10,
                        height: 10,
                        color: '#FFFFFF', // Line color (white)
                        backgroundColor: 'rgb(80, 87, 89)' // Background color (red)
                    }
                },
            }],
            states: {
                inactive: {
                    enabled: false,
                },
            },
        },
    ];
    var accessibility = {
        enabled: true,
        description: '',
        pointDescriptionFormatter: function (point) {
            return `${(point.y != undefined) ? `${point.name}: ${formatNumberWithCommas(point.y)}` : ``}; ${(linedUpOrderCost != undefined) ? `Lined-Up Order Cost: ${formatNumberWithCommas(linedUpOrderCost)}` : ``};`;
        },
        screenReaderSection: {
            beforeChartFormat: '' // disables their auto "Interactive chart" label
        }
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        Highcharts?.chart(`${id}`, json);        
    };
    useEffect(() => {
        initGraph();
    }, [id, simObj?.laststate?.totalProcurementCost,simObj?.laststate?.availableBudget,simObj?.laststate?.linedUpOrderCost]);
    return (
        <div
            id={id}
            style={{ height: "240px" }}
            aria-label="Remaining Budget Graph"
            className="RemainingBudget"
        ></div>
    );
}
